import { render, staticRenderFns } from "./ArrivesTodayShipping.vue?vue&type=template&id=14544728&"
import script from "./ArrivesTodayShipping.vue?vue&type=script&lang=js&"
export * from "./ArrivesTodayShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports